module.exports = __webpack_public_path__ + "assets/images/premium-features/tags-banner-new-0864a1.png";